import * as React from "react";
import Stack from "@mui/material/Stack";
import { styled } from "@mui/material/styles";
import DeleteIcon from "@mui/icons-material/Delete";
import MuiAccordion, { AccordionProps } from "@mui/material/Accordion";
import MuiAccordionSummary, { AccordionSummaryProps } from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ArrowForwardIosSharpIcon from "@mui/icons-material/ArrowForwardIosSharp";
import Typography from "@mui/material/Typography";
import { IconButton } from "@mui/material";

const AccordionControlled = ({ children, title, index = 0, key, remove, disabled }: any) => {
  const [expanded, setExpanded] = React.useState<string | false>(false);

  const handleChange = (panel: string) => (event: React.SyntheticEvent, isExpanded: boolean) => {
    setExpanded(isExpanded ? panel : false);
  };

  return (
    <TemplateContainer>
      <AccordionWrapper>
        <Accordion expanded={expanded === index} onChange={handleChange(index)}>
          <AccordionSummary
            expandIcon={<ArrowForwardIosSharpIcon sx={{ fontSize: "0.9rem" }} />}
            aria-controls='panel1a-content'
            id='panel1a-header'
          >
            <Stack
              spacing={1}
              direction='row'
              alignItems='center'
              justifyContent='space-between'
              sx={{ width: "100%" }}
            >
              <div>
                <Typography>{`${title} ${index + 1}`}</Typography>
              </div>
            </Stack>
          </AccordionSummary>

          <AccordionDetails>
            <div>{children}</div>
          </AccordionDetails>
        </Accordion>
      </AccordionWrapper>
      <Delete>
        <IconButton aria-label='delete' onClick={remove} disabled={disabled}>
          <DeleteIcon fontSize='small' />
        </IconButton>
      </Delete>
    </TemplateContainer>
  );
};

export default AccordionControlled;

const Delete = styled("div")`
  right: 40px;
  margin-top: 5px;
  position: relative;
  align-self: flex-start;
`;

const TemplateContainer = styled("div")`
  flex: 1;
  display: flex;
  align-items: center;
  flex-direction: row;
`;

const AccordionWrapper = styled("div")`
  width: 100%;
`;

const Accordion = styled((props: AccordionProps) => <MuiAccordion disableGutters elevation={0} square {...props} />)(
  ({ theme }) => ({
    border: `0.1px solid ${theme.palette.primary.main}`,
    margin: "1px",
    "&:before": {
      display: "none",
    },
  })
);

const AccordionSummary = styled((props: AccordionSummaryProps) => (
  <MuiAccordionSummary expandIcon={<ArrowForwardIosSharpIcon sx={{ fontSize: "0.9rem" }} />} {...props} />
))(({ theme }) => ({
  flexDirection: "row-reverse",
  "& .MuiAccordionSummary-expandIconWrapper.Mui-expanded": {
    transform: "rotate(90deg)",
  },
  "& .MuiAccordionSummary-content": {
    marginLeft: theme.spacing(1),
  },
}));
